export const demoProductsAddedByPlugin = {
    "type": "week",
    "stats": [
        {
            "period": {
                "from": "2024-12-30",
                "to": "2025-01-05"
            },
            "value": 22,
            "formatted_period": "2025.01.W1"
        },
        {
            "period": {
                "from": "2025-01-06",
                "to": "2025-01-12"
            },
            "value": 15,
            "formatted_period": "2025.01.W2"
        },
        {
            "period": {
                "from": "2025-01-13",
                "to": "2025-01-19"
            },
            "value": 17,
            "formatted_period": "2025.01.W3"
        },
        {
            "period": {
                "from": "2025-01-20",
                "to": "2025-01-26"
            },
            "value": 16,
            "formatted_period": "2025.01.W4"
        },
        {
            "period": {
                "from": "2025-01-27",
                "to": "2025-02-02"
            },
            "value": 25,
            "formatted_period": "2025.02.W1"
        },
        {
            "period": {
                "from": "2025-02-03",
                "to": "2025-02-09"
            },
            "value": 24,
            "formatted_period": "2025.02.W2"
        },
        {
            "period": {
                "from": "2025-02-10",
                "to": "2025-02-16"
            },
            "value": 34,
            "formatted_period": "2025.02.W3"
        },
        {
            "period": {
                "from": "2025-02-17",
                "to": "2025-02-23"
            },
            "value": 12,
            "formatted_period": "2025.02.W4"
        },
        {
            "period": {
                "from": "2025-02-24",
                "to": "2025-03-02"
            },
            "value": 30,
            "formatted_period": "2025.03.W1"
        },
        {
            "period": {
                "from": "2025-03-03",
                "to": "2025-03-09"
            },
            "value": 11,
            "formatted_period": "2025.03.W2"
        },
        {
            "period": {
                "from": "2025-03-10",
                "to": "2025-03-16"
            },
            "value": 17,
            "formatted_period": "2025.03.W3"
        },
        {
            "period": {
                "from": "2025-03-17",
                "to": "2025-03-23"
            },
            "value": 15,
            "formatted_period": "2025.03.W4"
        },
        {
            "period": {
                "from": "2025-03-24",
                "to": "2025-03-30"
            },
            "value": 18,
            "formatted_period": "2025.03.W5"
        }
    ]
}